import { Button, Flex, Text, useMantineTheme } from "@mantine/core";

type Props = {
  minRange?: number;
  maxRange?: number;
  minText?: string;
  maxText?: string;
  onSelectOption: (option: number) => void;
  selectedRange?: number;
};

export function RangeButtonOptions({
  minRange,
  maxRange,
  minText,
  maxText,
  onSelectOption,
  selectedRange,
}: Props) {
  const theme = useMantineTheme();
  if (maxRange === undefined || minRange === undefined) return null;

  const numButtons = maxRange - minRange + 1;

  const rangeButtons = Array.from({ length: numButtons }, (_, index) => {
    const value = minRange + index;
    const isSelected = Boolean(selectedRange === value);
    return (
      <Button
        key={value}
        size="lg"
        radius="md"
        variant="outline"
        color="white"
        px="xs"
        style={{ flexGrow: 1, minWidth: 0 }}
        styles={{
          root: {
            borderColor: isSelected ? theme.colors.lightBlue[0] : theme.white,
            borderWidth: isSelected ? "3px" : "1px",
            color: theme.white,
            transition: "all 0.1s ease-out",
          },
          label: {
            overflow: "visible",
          },
        }}
        onClick={() => onSelectOption(value)}
      >
        {value}
      </Button>
    );
  });

  return (
    <>
      <Flex justify="space-between">
        {minText && <Text>{minText}</Text>}
        {maxText && <Text>{maxText}</Text>}
      </Flex>
      <Flex gap="md">{rangeButtons}</Flex>
    </>
  );
}
